module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-circle-wrapper active",
    style: ({
      'width': _vm.size + 'px',
      'height': _vm.size + 'px'
    })
  }, [_c('div', {
    staticClass: "mu-circle-spinner active",
    class: {
      'mu-circle-secondary': _vm.secondary
    },
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "mu-circle-clipper left"
  }, [_c('div', {
    staticClass: "mu-circle",
    style: ({
      'border-width': _vm.borderWidth + 'px'
    })
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mu-circle-clipper right"
  }, [_c('div', {
    staticClass: "mu-circle",
    style: ({
      'border-width': _vm.borderWidth + 'px'
    })
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-circle-gap-patch"
  }, [_c('div', {
    staticClass: "mu-circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0aab530b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/internal/circular.vue
// module id = 416
// module chunks = 1